import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function SelectedRd1sReducer(state = initialState.selectedRd1s, action: any) {
  switch (action.type) {
    case types.SAVE_SELECTED_RD1S_SUCCESS:
      return action.selectedRd1s;
    default:
      return state;
  }
}
